import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { provideHttpClient, withInterceptors, HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@app/core/port/authentication.service';
import { AuthenticationOrchestratorService } from '@app/core/adapter/authentication-orchestrator.service';
import { initializeAutoConnectFactory } from '@app/core/initializer/auto-connect.initializer';
import { UserService } from '@app/core/port/user.service';
import { UserBackendService } from '@app/core/adapter/user-backend.service';
import { UserStore } from '@app/core/store/user.store';
import { DATA_SERVICE } from '@app/core/port/data.service';
import { DataLocalhostService } from '@app/core/adapter/data-localhost.service';
import { WebSocketService } from '@app/core/services/websocket.service';
import { initializeWebSocketFactory } from '@app/core/initializer/websocket-connect.initializer';
import { environment } from '@env/environment';
import { authInterceptor } from './core/interceptors/auth.interceptor';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),

    {
      provide: DATA_SERVICE,
      useClass:
        environment.dataProvider === 'local'
          ? DataLocalhostService
          : DataLocalhostService,
    },
    // Configuration des services d'authentification et utilisateur
    {
      provide: AuthenticationService,
      useClass: AuthenticationOrchestratorService,
    },
    {
      provide: UserService,
      useClass: UserBackendService,
    },
    // Auto-connect réactivé avec diagnostics complets
    provideAppInitializer(() => {
      if (!environment.production) {
        console.log('🚀 AppInitializer en cours d\'exécution...');
      }
      const obs = initializeAutoConnectFactory(
        inject(AuthenticationService),
        inject(UserService),
        inject(UserStore),
        inject(Router),
        inject(HttpClient)
      )();
      
      return obs.toPromise().then(() => {
        if (!environment.production) {
          console.log('✅ AppInitializer terminé');
        }
      }).catch((error) => {
        console.error('❌ Erreur AppInitializer:', error);
      });
    }),

    // WebSocket auto-connect
    provideAppInitializer(() => {
      const initFn = initializeWebSocketFactory(inject(WebSocketService));
      return initFn();
    }),
  ],
};